import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-solar-blue text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/24848c9e-ecf8-4995-b70c-f54ceefe879e.png"
              alt="BRICK CITY SOLAR, LLC"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-gray-300 mb-4">
              Professional solar energy solutions for homes and businesses in Ocala, Florida.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-energy-yellow hover:text-solar-blue transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-energy-yellow hover:text-solar-blue transition-all cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-energy-yellow hover:text-solar-blue transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-full hover:bg-energy-yellow hover:text-solar-blue transition-all cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-energy-yellow transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-300 hover:text-energy-yellow transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/residential" className="text-sm text-gray-300 hover:text-energy-yellow transition-colors">
                  Residential Solar
                </Link>
              </li>
              <li>
                <Link to="/commercial" className="text-sm text-gray-300 hover:text-energy-yellow transition-colors">
                  Commercial Solar
                </Link>
              </li>
              <li>
                <Link to="/financing" className="text-sm text-gray-300 hover:text-energy-yellow transition-colors">
                  Financing
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-sm text-gray-300">Solar Panel Installation</li>
              <li className="text-sm text-gray-300">System Design</li>
              <li className="text-sm text-gray-300">Energy Consultation</li>
              <li className="text-sm text-gray-300">Maintenance & Support</li>
              <li className="text-sm text-gray-300">Financing Options</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-energy-yellow mt-1 mr-3"></i>
                <span className="text-sm text-gray-300">
                  3948 SE 15TH ST<br />
                  OCALA, FL 34471
                </span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-energy-yellow mr-3"></i>
                <a href="tel:352-509-6933" className="text-sm text-gray-300 hover:text-energy-yellow transition-colors">
                  352-509-6933
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-time-line text-energy-yellow mr-3"></i>
                <span className="text-sm text-gray-300">Mon-Fri: 8AM - 5PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-300">
            &copy; {new Date().getFullYear()} BRICK CITY SOLAR, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;